module.exports = __webpack_public_path__ + "static/media/ThumbsUp_selected.d159c76d.svg";